/**
 * Single source of truth for tenant sidebar menu structure.
 * Used by:
 * - Sidebar.jsx: builds nav items with role-based filtering
 * - VisualSettings.jsx MenuOrderPanel: displays reorderable list
 *
 * When adding a new menu item, add it here - both Sidebar and Menu Order panel
 * will automatically pick it up.
 *
 * Structure: { path, label, iconKey?, enabled?, subItems?: [...] }
 * MenuOrderPanel uses path and label only; Sidebar uses full structure.
 */
export const DEFAULT_TENANT_MENU_ITEMS = [
  { path: '/tenant/dashboard', label: 'Dashboard', iconKey: 'dashboard', enabled: true, subItems: [] },
  {
    path: '/tenant/sales',
    label: 'Sales',
    iconKey: 'sales',
    enabled: true,
    subItems: [
      { path: '/tenant/invoices/new', label: 'Create new invoice', iconKey: 'create', enabled: true },
      { path: '/tenant/invoices', label: 'View Invoices', iconKey: 'invoices', enabled: true },
      { path: '/tenant/estimates/new', label: 'Create New Estimates', iconKey: 'create', enabled: true },
      { path: '/tenant/estimates', label: 'View Estimates', iconKey: 'estimates', enabled: true },
      { path: '/tenant/clients', label: 'Client Management', iconKey: 'clients', enabled: true },
      { path: '/tenant/client-portal-messages', label: 'Client portal messages', iconKey: 'clientMessages', enabled: true },
    ],
  },
  {
    path: '/tenant/purchases',
    label: 'Purchases',
    iconKey: 'purchases',
    enabled: true,
    subItems: [
      { path: '/tenant/purchases/new', label: 'Create new purchase', iconKey: 'create', enabled: true },
      { path: '/tenant/purchases', label: 'All Purchases', iconKey: 'purchases', enabled: true },
      { path: '/tenant/suppliers', label: 'Supplier Management', iconKey: 'suppliers', enabled: true },
    ],
  },
  {
    path: '/tenant/certificates',
    label: 'Certificates',
    iconKey: 'certificates',
    enabled: true,
    subItems: [
      { path: '/tenant/certification', label: 'Electrical', iconKey: 'electrical', enabled: true },
      { path: '/tenant/certification/fire', label: 'Fire', iconKey: 'fire', enabled: false },
      { path: '/tenant/certification/security', label: 'Security', iconKey: 'security', enabled: false },
      { path: '/tenant/certification/cctv', label: 'CCTV', iconKey: 'cctv', enabled: false },
    ],
  },
  { path: '/tenant/banking', label: 'Banking', iconKey: 'banking', enabled: true, subItems: [] },
  { path: '/tenant/reports', label: 'Reports', iconKey: 'reports', enabled: true, subItems: [] },
  {
    path: '/tenant/tools',
    label: 'Tools',
    iconKey: 'tools',
    enabled: true,
    subItems: [
      { path: '/tenant/tools/rams', label: 'RAMS', iconKey: 'rams', enabled: true },
      { path: '/tenant/tools/calculators', label: 'Calculators', iconKey: 'calculators', enabled: true },
      { path: '/tenant/tools/design', label: 'Design', iconKey: 'design', enabled: true },
      { path: '/tenant/tools/pricing', label: 'Pricing', iconKey: 'pricing', enabled: true },
      { path: '/tenant/tools/knowledge-base', label: 'Knowledge base', iconKey: 'knowledgeBase', enabled: true },
      { path: '/tenant/tools/planner', label: 'Planner', iconKey: 'planner', enabled: true },
    ],
  },
  { path: '/tenant/vehicles', label: 'Vehicles/Fleet', iconKey: 'fleet', enabled: true, subItems: [] },
  {
    path: '/tenant/settings',
    label: 'Settings',
    iconKey: 'settings',
    enabled: true,
    subItems: [],
  },
];
